/* Bootstrap's collapse, driven from Angular so there is one owner of the
   open/closed state. Used by the category accordions (shop sidebar,
   side-drawer). Bootstrap's JS is imported per module (collapse here and in
   new-checkout, modal in my-rewards); there is no global bootstrap.bundle. */
import Collapse from 'bootstrap/js/dist/collapse';

/** Open the collapse with this id (closing siblings under `parent`). */
export function uiExpand(id: string, parent?: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  Collapse.getOrCreateInstance(el, { toggle: false, parent }).show();
}

/** Toggle the collapse with this id. */
export function uiToggle(id: string, parent?: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  Collapse.getOrCreateInstance(el, { toggle: false, parent }).toggle();
}
